import React, { useContext, useEffect, useMemo, useState } from "react";
import { Grid } from "react-feather";
import { Link, useLocation } from "react-router-dom";
import CustomizerContext from "../../Helper/Customizer";
import { Image } from "../../AbstractElements";
import FwLogo from "./FwLogo";
import { readLocationCache } from "../../helpers/locationCache";
import { isLocationSidebarContext } from "../../helpers/locationContext";

const SIDEBAR_LOGO_URL =
  "https://cloud.fairyland.world/upload/cloud/17492/91870_AltnomyrIF_crop.jpg";

const SidebarLogo = () => {
  const { togglSidebar, setTogglSidebar } = useContext(CustomizerContext);
  const { pathname, search } = useLocation();
  const [cacheTick, setCacheTick] = useState(0);

  useEffect(() => {
    const onCache = () => setCacheTick((n) => n + 1);
    window.addEventListener("cpai-location-cache-updated", onCache);
    return () => window.removeEventListener("cpai-location-cache-updated", onCache);
  }, []);

  /* Внутри локации в шапке сайдбара стоит её собственная картинка — так
     видно, чьи данные сейчас открыты. Вне локации — знак платформы из
     макета: он векторный и не зависит от доступности cloud. */
  const location = useMemo(() => {
    const inLocation = isLocationSidebarContext(pathname, search);
    const locationIdParam = new URLSearchParams(search).get("location_id");
    const locationId = locationIdParam ? parseInt(locationIdParam, 10) : NaN;
    if (!inLocation || Number.isNaN(locationId)) return null;

    const cached = readLocationCache();
    if (cached && cached.id === locationId && cached.image) {
      return {
        src: cached.image,
        alt: cached.name ? String(cached.name) : "Локация",
      };
    }
    return { src: SIDEBAR_LOGO_URL, alt: "Локация" };
  }, [pathname, search, cacheTick]);

  return (
<>
      {/* Логотип ведёт на «Главную», а не на демо-дашборд шаблона: тот
          убран из меню, и попасть на него можно было только отсюда — по
          клику человек оказывался на чужой странице с виджетами. */}
      <Link className="fw-brand" to={`${process.env.PUBLIC_URL}/home`}>
        {location ? (
          <Image
            attrImage={{
              className: "img-fluid for-light sidebar-brand-logo",
              src: location.src,
              alt: location.alt,
            }}
          />
        ) : (
          <>
            <FwLogo className="fw-brand-mark" />
            <b>Волшебный Мир</b>
          </>
        )}
      </Link>
      <div className="back-btn" onClick={() => setTogglSidebar(!togglSidebar)}>
        <Grid />
      </div>
      <div className="toggle-sidebar"  onClick={() => setTogglSidebar(!togglSidebar)}>
        <Grid className="status_toggle middle sidebar-toggle" />
      </div>
</>
  );
};

export default SidebarLogo;
